import React from "react";
import { CardStyled as HeadCard } from "../../custom/cards/card.styled";
import {
  CardText,
  CardTitle,
  CardUserFullName,
  CardUserId,
  CustomDivider,
  ImageContainer,
  UserCardBody,
} from "./report-cards.styled";
import { Image, Space } from "@nubeteck/components";
import { UserReportIconSVG } from "../../../assets";
import { useMediaQuery } from "src/hooks";
import { useLocale } from "../../../i18n/localeContext";
import { getBoxPage } from "../../../Api/content";
import { useState, useEffect } from "react";
import { Skeleton } from "antd";
import { StrapiError } from "../../../pages/StrapiError";

interface IUserInfoCardProps {
  nombre: string;
  id: string;
  extraContent: React.ReactNode;
}

const UserInfoCard = ({ nombre, id, extraContent }: IUserInfoCardProps) => {
  const { locale } = useLocale();
  const [boxPage, setBoxPage] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState<boolean>(true);
  const [hasError, setHasError] = useState<boolean>(false);
  const smallScreen = useMediaQuery("(max-width: 1024px)");
  const tabletMode = useMediaQuery("(max-width: 768px)");

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);
    
    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setBoxPage(null);
        setIsLoadingContent(false);
        setHasError(locale === 'en');
      }
    }, 3000);

    getBoxPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setBoxPage(null);
          setIsLoadingContent(false);
          setHasError(locale === 'en');
        }
      });
    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]);

  if (hasError && locale === 'en') {
    return <StrapiError
      onRetry={() => {
        setHasError(false);
        setIsLoadingContent(true);
      }}
      onUseDefault={() => {
        setHasError(false);
        setIsLoadingContent(false);
        setBoxPage(null);
      }}
    />;
  }

  return (
    <HeadCard
      bodyStyle={{
        padding: 7,
        display: "flex",
        alignItems: "center",
        minWidth: !smallScreen ? "870px" : !tabletMode ? "765px" : "auto",
      }}
      style={{ minWidth: 300, flex: "1" }}
    >
      <UserCardBody>
        <CardUserFullName>
          <ImageContainer>
            <Image preview={false} src={UserReportIconSVG} width={32} />
          </ImageContainer>
          <Space direction="vertical" style={{ paddingTop: 10 }}>
            <CardTitle>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.name || "Nombre")}</CardTitle>
            <CardText>{nombre}</CardText>
          </Space>
        </CardUserFullName>
        <CustomDivider />
        <CardUserId direction="vertical">
          <CardTitle>{isLoadingContent ? <Skeleton.Input active size="default" style={{ width: 100 }} /> : (boxPage?.id_code || "ID")}</CardTitle>
          <CardText>{id}</CardText>
        </CardUserId>
        {extraContent ? (
          <>
            <CustomDivider /> {extraContent}
          </>
        ) : null}
      </UserCardBody>
    </HeadCard>
  );
};

export default UserInfoCard;
